import { render, staticRenderFns } from "./CheckAndSendForm.vue?vue&type=template&id=08a73149&"
import script from "./CheckAndSendForm.vue?vue&type=script&lang=ts&"
export * from "./CheckAndSendForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports